const formatter = new Intl.NumberFormat('en-US', {
	style: 'currency',
	currency: 'USD',
});

export { formatter };

/* eslint-disable @typescript-eslint/no-shadow */
export function formatCurrency(value: number): string {
	const formatter = new Intl.NumberFormat('en-US', {
		style: 'currency',
		currency: 'USD',
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	});

	return formatter.format(value);
}
/* eslint-enable @typescript-eslint/no-shadow */
